// This file is provided by Jason Otis from UX.

/*  = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = =
   #DESIGN TOKENS
    = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = */
/* WIP */
// Building a list of variables in prep for design tokens.

/* Palettes
   ========================================================================== */

export const color_white = "white";
export const color_black = "black";

// ResMed Brand colors
export const res_brand_color_001 = "#1788c3";
export const res_brand_color_002 = "#008fd5";
export const res_brand_color_003 = "#0083ca";
export const res_brand_color_004 = "#0077c0";
export const res_brand_color_005 = "#006db7";
export const res_brand_color_006 = "#2062af";
export const res_brand_color_007 = "#4156a6";
export const res_brand_color_008 = "#55489d";
export const res_brand_color_009 = "#643695";
export const res_brand_color_010 = "#6f2c91";
export const res_brand_color_011 = "#822a85";
export const res_brand_color_012 = "#94287b";
export const res_brand_color_013 = "#9d2872";
export const res_brand_color_014 = "#a52868";
export const res_brand_color_015 = "#ae275f";
export const res_brand_color_016 = "#b72755";
export const res_brand_color_017 = "#c02550";
export const res_brand_color_018 = "#c9234a";
export const res_brand_color_019 = "#d12244";
export const res_brand_color_020 = "#da1f3d";
export const res_brand_color_021 = "#e31e36";
export const res_brand_color_022 = "#ed1b2f";

// $res_brand_color_001 based color palette
export const res_001_palette_50 = "#e7f5fc";
export const res_001_palette_100 = "#a3d8f4";
export const res_001_palette_200 = "#70c3ee";
export const res_001_palette_300 = "#31a8e7";
export const res_001_palette_400 = "#1a9bde";
export const res_001_palette_500 = "#1788c3";
export const res_001_palette_600 = "#1475a8";
export const res_001_palette_700 = "#11628c";
export const res_001_palette_800 = "#0d4f71";
export const res_001_palette_900 = "#0a3c55";

// Primary
// $res-brand-color-002 based color palette
export const res_002_palette_50 = "#dff5ff";
export const res_002_palette_100 = "#93dbff";
export const res_002_palette_200 = "#5bc9ff";
export const res_002_palette_300 = "#13b1ff";
export const res_002_palette_400 = "#00a4f4";
export const res_002_palette_500 = "#008fd5";
export const res_002_palette_600 = "#007ab6";
export const res_002_palette_700 = "#006698";
export const res_002_palette_800 = "#005179";
export const res_002_palette_900 = "#003d5b";

// Grey
export const res_grey_50 = "#f6f6f6";
export const res_grey_100 = "#f2f2f2";
export const res_grey_200 = "#e6e6e7";
export const res_grey_300 = "#d9d8d5";
export const res_grey_400 = "#b7b7b8";
export const res_grey_500 = "#9b9b9e";
export const res_grey_600 = "#787878";
export const res_grey_700 = "#6d6d6d";
export const res_grey_800 = "#424243";
export const res_grey_900 = "#212121";

// Non_ResMed_Spectrum color palettes
// Color names not part of the ResMed spectrum come from = https =//www.colorhexa.com/

export const res_light_blue_50 = "#e1f5fe";
export const res_light_blue_100 = "#b3e5fc";
export const res_light_blue_200 = "#81d4fa";
export const res_light_blue_300 = "#4fc3f7";
export const res_light_blue_400 = "#29b6f6";
export const res_light_blue_500 = "#03a9f4";
export const res_light_blue_600 = "#0394d6";
export const res_light_blue_700 = "#027fb8";
export const res_light_blue_800 = "#026a99";
export const res_light_blue_900 = "#02557b";

export const res_blue_grey_50 = "#9dacc2";
export const res_blue_grey_100 = "#6e84a5";
export const res_blue_grey_200 = "#546887";
export const res_blue_grey_300 = "#38465b";
export const res_blue_grey_400 = "#2d3848";
export const res_blue_grey_500 = "#212935";
export const res_blue_grey_600 = "#151a22";
export const res_blue_grey_700 = "#0a0c0f";
export const res_blue_grey_800 = "#0b0f16";
export const res_blue_grey_900 = "#000000";

export const res_light_yellow_50 = "#fffbeb";
export const res_light_yellow_100 = "#fff5cc";
export const res_light_yellow_200 = "#ffefaa";
export const res_light_yellow_300 = "#ffe888";
export const res_light_yellow_400 = "#ffe36f";
export const res_light_yellow_500 = "#ffde55";
export const res_light_yellow_600 = "#ffda4e";
export const res_light_yellow_700 = "#ffd544";
export const res_light_yellow_800 = "#ffd13b";
export const res_light_yellow_900 = "#ffc82a";

export const res_light_orange_50 = "#fff8e9";
export const res_light_orange_100 = "#ffedc7";
export const res_light_orange_200 = "#ffe1a2";
export const res_light_orange_300 = "#ffd57c";
export const res_light_orange_400 = "#ffcc60";
export const res_light_orange_500 = "#ffc344";
export const res_light_orange_600 = "#ffbd3e";
export const res_light_orange_700 = "#ffb535";
export const res_light_orange_800 = "#ffae2d";
export const res_light_orange_900 = "#ffa11f";

export const res_mod_green_50 = "#edf6ea";
export const res_mod_green_100 = "#d3e9cc";
export const res_mod_green_200 = "#b6daaa";
export const res_mod_green_300 = "#98cb87";
export const res_mod_green_400 = "#82bf6e";
export const res_mod_green_500 = "#6cb454";
export const res_mod_green_600 = "#64ad4d";
export const res_mod_green_700 = "#59a443";
export const res_mod_green_800 = "#4f9c3a";
export const res_mod_green_900 = "#3d8c29";

// Contrast colors for text on color surfaces.
export const dark_primary_text = "rgba(black, 0.87)";
export const dark_secondary_text = "rgba(black, 0.54)";
export const dark_disabled_text = "rgba(black, 0.38)";
export const dark_dividers = "rgba(black, 0.12)";
export const dark_focused = "rgba(black, 0.12)";

export const light_primary_text = color_white;
export const light_secondary_text = "rgba(white, 0.8)";
export const light_disabled_text = "rgba(white, 0.5)";
export const light_dividers = "rgba(white, 0.12)";
export const light_focused = "rgba(white, 0.12)";

/* Theme colors
   ========================================================================== */
// Global color variables created from the theme configs.
export const primary = res_002_palette_500;
export const primary_hover = res_002_palette_400;
export const primary_active = res_002_palette_700;
export const primary_contrast = color_white;
export const primary_light = res_002_palette_200;
export const primary_dark = res_002_palette_700;

export const secondary = res_grey_100;

export const color_danger = res_brand_color_020;
export const color_success = res_mod_green_500;
export const color_warning = res_light_orange_500;
export const color_dark = res_grey_800;

/* Background Colors
   ========================================================================== */
export const color_background = color_white;
export const color_background_alt = secondary;

export const color_background_footer = color_dark;

export const color_background_primary = primary;
export const color_background_dark = color_dark;
export const color_background_success = color_success;
export const color_background_warning = color_warning;
export const color_background_danger = color_danger;
export const color_background_light = secondary;

export const color_background_gradient =
  "linear-gradient(270deg, #008fd5 0%, #0083ca 100%)";

export const color_background_tooltip = res_blue_grey_500;
export const color_background_selection = res_light_yellow_500;

/* Text Colors
   ========================================================================== */
export const color_text_default = color_dark;
export const color_text_secondary = dark_secondary_text;
export const color_text_disabled = dark_disabled_text;
export const color_text_inverse = color_white;

export const color_text_error = res_brand_color_020;
export const color_text_success = res_mod_green_500;
export const color_text_warning = res_light_orange_500;

export const color_icon_default = res_grey_700;
export const color_icon_hover = color_black;

export const color_text_link = primary;
export const color_text_visited = res_brand_color_007;
export const color_text_hover = primary_hover;
export const color_text_active = primary_active;

export const color_text_footer = light_secondary_text;

/* Border Colors
   ========================================================================== */
export const global_border_color = res_grey_200;

/* Spacing
   ========================================================================== */
export const global_unit = "24px";
export const global_unit_micro = "3px";
export const global_unit_tiny = "6px";
export const global_unit_small = "12px";
export const global_unit_medium = "36px";
export const global_unit_large = "48px";
export const global_unit_xlarge = "72px";
export const global_unit_huge = "96px";

/* Global
   ========================================================================== */
export const global_font_size = "16px";
export const global_icon_size = "24px";
export const global_ddlb_arrow_size = "16px";
export const input_field_height = "38px";
export const opacity_disabled = "0.3";
export const button_min_width = "186px";
export const m_button_max_width = "252px";

// Radius
export const global_radius = "3px";
export const button_radius = "420px";
export const pill_radius = "420px";
export const card_radius = "6px";
export const dialog_radius = "6px";

// Shadow
export const global_box_shadow = "0 2px 5px  rgba(res_grey_200, 0.6)";
export const global_box_shadow_hover = "0 4px 15px rgba(res_grey_400, 0.6)";

/* Typography
   ========================================================================== */
export const import_opensans =
  'https =//fonts.googleapis.com/css2?family =Open+Sans =ital,wght@0,300";0,400";0,600";0,700";0,800";1,300";1,400";1,600";1,700";1,800&display =swap';
export const font_family =
  '"Open Sans", "Helvetica Neue", "Helvetica", Helvetica, Arial, sans_serif"';

// Font weights
export const font_weight_thin = 100;
export const font_weight_light = 300;
export const font_weight_normal = 400;
export const font_weight_medium = 600;
export const font_weight_bold = 700;
export const font_weight_extra = 800;
export const font_weight_black = 900;

// Font sizes
export const font_size_h1 = "50px";
export const font_size_h2 = "36px";
export const font_size_h3 = "28px";
export const font_size_h4 = "24px";
export const font_size_h5 = "20px";
export const font_size_h6 = "17px";

export const font_weight_h1 = font_weight_medium;
export const font_weight_h2 = font_weight_medium;
export const font_weight_h3 = font_weight_bold;
export const font_weight_h4 = font_weight_bold;
export const font_weight_h5 = font_weight_medium;
export const font_weight_h6 = font_weight_bold;

export const font_size_site_nav = "16px";
export const font_size_body = "16px";
export const font_size_button = "16px";
export const font_size_tooltip = "14px";
export const font_size_form_label = "16px";
export const font_size_form_hint = "14px";
export const font_size_form_error = "14px";
export const font_size_small = "14px";
export const font_size_caption = "12px";
export const font_size_footer = "14px";

export const font_weight_site_nav = font_weight_medium;
export const font_weight_body = font_weight_light;
export const font_weight_button = font_weight_bold;
export const font_weight_tooltip = font_weight_medium;
export const font_weight_form_label = font_weight_medium;
export const font_weight_form_hint = font_weight_normal;
export const font_weight_form_error = font_weight_medium;
export const font_weight_small = font_weight_medium;
export const font_weight_caption = font_weight_medium;
export const font_weight_footer = font_weight_medium;

export const font_size_input = "21px";
export const font_size_input_mobile = "18px";

/* PAGE HEADER
   ========================================================================== */
export const page_head_min_height = "84px";
export const page_head_bgcolor = color_background_gradient;

/* SITENAV
   ========================================================================== */
export const site_nav_link_color = color_white;
export const site_nav_hover_color = color_white;
export const site_nav_active_color = color_white;
export const site_nav_hover_bgcolor = "rgba(white, 0.1)";
export const site_nav_active_bgcolor = "rgba(white, 0.1)";

export const site_nav_font_size = font_size_site_nav;
export const site_nav_font_weight = font_weight_site_nav;

/* BUTTONS
   ========================================================================== */
export const c_btn_height = input_field_height;
export const c_btn_icon_size = global_icon_size;
export const c_btn_font_size = font_size_button;
export const c_btn_font_weight = font_weight_button;
export const c_btn_letter_spacing = "1px";
export const c_btn_radius = button_radius;
export const c_btn_opacity_disabled = opacity_disabled;

export const c_btn_focus_outline_style = "solid";
export const c_btn_focus_outline_size = "3px";
export const c_btn_focus_outline_opacity = "0.28";

export const c_btn_short = "120px";
export const c_btn_wide = "240px";
export const c_btn_min_width = button_min_width;
export const c_btn_max_width_mobile = m_button_max_width;

export const c_btn_padding_y_mobile = "9px";
export const c_btn_padding_x_mobile = global_unit;
export const c_btn_padding_y = "0";
export const c_btn_padding_x = global_unit_medium;
export const c_btn_padding_icon =
  c_btn_padding_x + c_btn_icon_size + global_unit_tiny;

export const c_btn_primary_text_color = primary_contrast;
export const c_btn_primary_bgcolor = primary;
export const c_btn_primary_hover_bgcolor = primary_hover;
export const c_btn_primary_active_bgcolor = primary_active;
export const c_btn_primary_inverse_text_color = c_btn_primary_bgcolor;
export const c_btn_primary_inverse_hover_color = c_btn_primary_hover_bgcolor;
export const c_btn_primary_inverse_active_color = c_btn_primary_active_bgcolor;
export const c_btn_primary_inverse_bgcolor = color_white;
export const c_btn_primary_inverse_hover_bgcolor = "rgba(white,0.87)";

export const c_btn_secondary_text_color = primary;
export const c_btn_secondary_border_width = "1px";
export const c_btn_secondary_border_style = "solid";
export const c_btn_secondary_border_color = primary;
export const c_btn_secondary_hover_border_width = "1px";
export const c_btn_secondary_bgcolor = "transparent";
export const c_btn_secondary_hover_bgcolor = "transparent";
export const c_btn_secondary_active_bgcolor = "transparent";
export const c_btn_secondary_inverse_text_color = color_text_inverse;
export const c_btn_secondary_inverse_border_color = color_text_inverse;

export const c_btn_tertiary_text_color = color_text_default;
export const c_btn_tertiary_border_width = "1px";
export const c_btn_tertiary_border_style = "solid";
export const c_btn_tertiary_border_color = color_text_default;
export const c_btn_tertiary_hover_border_width = "1px";
export const c_btn_tertiary_bgcolor = "transparent";
export const c_btn_tertiary_hover_bgcolor = "transparent";
export const c_btn_tertiary_active_bgcolor = "transparent";
export const c_btn_tertiary_inverse_text_color = color_text_inverse;
export const c_btn_tertiary_inverse_border_color = color_text_inverse;

export const c_btn_text_text_color = primary;
export const c_btn_text_hover_color = primary_hover;
export const c_btn_text_inverse_text_color = color_text_inverse;

/* CARDS
   ========================================================================== */
export const c_card_bgcolor = color_background;
export const c_card_border_radius = card_radius;
export const c_card_heading_color = color_text_default;
export const c_card_heading_size = font_size_h5;
export const c_card_heading_weight = font_weight_h5;
export const c_card_text_color = color_text_secondary;
export const c_card_text_font_size = global_font_size;
export const c_card_box_shadow = global_box_shadow;
export const c_card_box_shadow_hover = global_box_shadow_hover;

/* FORMS
   ========================================================================== */

// Form input labels
export const c_form_field_label_font_size = font_size_form_label;
export const c_form_field_label_line_height = "1.25";
export const c_form_field_label_font_weight = font_weight_form_label;
export const c_form_field_label_color = color_text_secondary;
export const c_form_field_readonly_font_weight = font_weight_bold;

// Hint text for fields
export const c_form_field_hint_font_size = font_size_form_hint;
export const c_form_field_hint_line_height = "1.25";
export const c_form_field_hint_font_weight = font_weight_form_hint;
export const c_form_field_hint_color = color_text_secondary;

// Inline error messages
export const c_form_field_error_font_size = font_size_form_error;
export const c_form_field_error_line_height = "1.125";
export const c_form_field_error_font_weight = font_weight_form_error;
export const c_form_field_error_color = color_danger;

// Form input fields
export const c_input_max_width = "376px";
export const c_input_height = input_field_height;
export const c_input_bgcolor = "transparent";
export const c_input_text_color = color_text_default;
export const c_input_font_size_mobile = font_size_input_mobile;
export const c_input_font_size_desktop = font_size_input;
export const c_input_padding_patient = "0";
export const c_input_padding_provider = "0" + global_unit_small;

export const c_input_border_width = "1px";
export const c_input_border_color = dark_dividers;
export const c_input_border_color_focus = primary;
export const c_input_border_radius = global_radius;
export const c_input_opacity_disabled = opacity_disabled;

export const c_input_number_max_width = "120px";
export const c_input_textarea_min_height = "120px";
export const c_input_textarea_border_width = "1px";
export const c_input_textarea_width_tablet = "600px";
export const c_input_textarea_bgcolor = color_white;

export const c_input_select_bgcolor = "transparent";
export const c_input_select_arrow_size = global_ddlb_arrow_size;
export const c_input_radiocheck_bgcolor = res_002_palette_50;
